import React from 'react';
import { STATIC_UPPSALA_SVG_URL } from '../../../lib/constants';
const DateInput = (props) => {
    return (React.createElement("div", { className: `${props.className ?? ''}`, style: {
            marginBottom: '15px',
            ...props.style,
        } },
        React.createElement("div", null,
            props.label && (React.createElement("label", { htmlFor: props.id, className: "form-label" }, props.label)),
            React.createElement("div", { className: "flex flex-row" },
                React.createElement("input", { id: props.id, name: props.name, value: props.value, defaultValue: props.defaultValue, max: props.max ?? '3000-12-31', min: props.min, required: props.required, disabled: props.disabled ?? false, type: "date", onChange: props?.onChange, onKeyDown: (event) => {
                        if (event.key === 'Enter') {
                            props.onEnter?.(event);
                        }
                    }, className: `form-control ${renderValidationClassName()}`, style: {
                        width: '250px',
                        height: "40px",
                        border: '1px solid #ddd',
                        borderRadius: '0px',
                    } }),
                React.createElement("div", { style: { width: '25px', marginLeft: '10px', display: 'flex', justifyContent: 'center' } }, renderIcon())),
            props.invalidMessage && props.valid === false ? (React.createElement("span", { style: { color: 'red' } }, props.invalidMessage)) : null)));
    function renderValidationClassName() {
        if (props.valid === true)
            return 'validation-successful';
        if (props.valid === false)
            return 'validation-error';
        return '';
    }
    function renderIcon() {
        if (props.valid === true)
            return React.createElement("img", { src: STATIC_UPPSALA_SVG_URL + 'check-mark.svg', alt: "check-mark" });
        if (props.valid === false)
            return React.createElement("img", { src: STATIC_UPPSALA_SVG_URL + 'x-mark.svg', alt: "x-mark" });
        return null;
    }
};
export default DateInput;
